import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { loadRawEntityDataByID } from '@adornis/bh-util/util.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class LecturerContractFile extends AdornisFile {
  static override _class = 'LecturerContractFile';
}

export enum LecturerContractVariable {
  Vorname = 'Vorname',
  Nachname = 'Nachname',
  Anschrift = 'Anschrift',
  Produkt_Titel = 'Produkt_Titel',
  Produkt_Tag = 'Produkt_Tag', // Wochentag
  Produkt_Datum = 'Produkt_Datum',
  Produkt_Uhrzeit = 'Produkt_Uhrzeit',
  Semester = 'Semester',
  Datum = 'Datum',
  Verguetung_Euro = 'Verguetung_Euro',
  Verguetung_Ausgeschrieben = 'Verguetung_Ausgeschrieben',
}

/**
 * @entity LecturerContract
 */
@Entity()
export class LecturerContract extends MongoEntity {
  static override _class = 'LecturerContract';
  static override _collectionName = 'lecturer-contracts';

  @Field(type => String)
  @validate(nonOptional())
  title!: string;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @Field(type => String)
  @validate(nonOptional())
  text!: string;

  @Field(type => String)
  fileID!: string;

  @Field(type => LecturerContractFile, {
    resolve: function (this: LecturerContract) {
      return async gqlFields => {
        const data = await loadRawEntityDataByID(LecturerContractFile, this.fileID);
        return data as LecturerContractFile;
      };
    },
  })
  file: Maybe<LecturerContractFile>;

  @validate(nonOptional())
  @Field(type => String)
  public institutionID!: string;
}
